<template>
  <div class="w-full h-full rounded-full flex items-center justify-center text-white"
       :class="{'bg-green': assetType === 1,
                'bg-yellow': assetType === 2,
                'bg-text-label': assetType === 3,
                'bg-border': assetType === 4,
                'bg-border-hover': assetType === 5}">
    <IconStock v-if="assetType === 1"></IconStock>
    <IconBond v-else-if="assetType === 2"></IconBond>
    <IconFund v-else-if="assetType === 3"></IconFund>
    <IconOtherAsset v-else-if="assetType === 5" ></IconOtherAsset>
  </div>
</template>

<script>
import IconBond from "@/components/icons/IconBond";
import IconStock from "@/components/icons/IconStock";
import IconFund from "@/components/icons/IconFund";
import IconOtherAsset from "@/components/icons/IconOtherAsset";

export default {
  name: "AssetGroupIcon",
  components: {IconFund, IconStock, IconBond,IconOtherAsset},
  props: {
    assetType: {
      type: Number
    }
  }
}
</script>